import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable, ReplaySubject, switchMap, take, tap } from 'rxjs';

import { environment } from 'environments/environment';

import { Shortcut } from './shortcuts.types';
import { ResponseRest } from 'app/interface/response-rest';


@Injectable({ providedIn: 'root' })
export class ShortcutsService {

    private _shortcuts: ReplaySubject<Shortcut[]> = new ReplaySubject<Shortcut[]>(1);

    private url: string = environment.urlAuth + "/Account";

    constructor(private _httpClient: HttpClient) {
    }

    get shortcuts$(): Observable<Shortcut[]> {
        return this._shortcuts.asObservable();
    }


    getAll(): Observable<ResponseRest> {
        const group = environment.ApiKey;
        let url = `${this.url}/Application/${group}`;

        return this._httpClient
            .get<ResponseRest>(url)
            .pipe(
                tap((response) => {
                    this._shortcuts.next(response.Data);
                }),
            );
    }

}
